import {
  limitedReleaseByVersionConstants,
  createLimitedReleaseByVersionConstants,
  editLimitedReleaseByVersionConstants,
  addTargetLimitedReleaseByVersionConstants,
  removeTargetLimitedReleaseByVersionConstants,
  activateLimitedReleaseByVersionConstants,
  deactivateLimitedReleaseByVersionConstants,
  deleteLimitedReleaseByVersionConstants,
} from "../_redux-constants/";

export function limitedReleasesVersionReducer(
  state = {
    limitedReleaseByVersionLoading: false,
    limitedReleaseByVersionData: null,
    limitedReleaseByVersionError: null,

    createLimitedReleaseByVersionLoading: false,
    createLimitedReleaseByVersionData: null,
    createLimitedReleaseByVersionError: null,

    editLimitedReleaseByVersionLoading: false,
    editLimitedReleaseByVersionData: null,
    editLimitedReleaseByVersionError: null,

    addTargetLimitedReleaseByVersionLoading: false,
    addTargetLimitedReleaseByVersionData: null,
    addTargetLimitedReleaseByVersionError: null,

    removeTargetLimitedReleaseByVersionLoading: false,
    removeTargetLimitedReleaseByVersionData: null,
    removeTargetLimitedReleaseByVersionError: null,

    activateLimitedReleaseByVersionLoading: false,
    activateLimitedReleaseByVersionData: null,
    activateLimitedReleaseByVersionError: null,

    deactivateLimitedReleaseByVersionLoading: false,
    deactivateLimitedReleaseByVersionData: null,
    deactivateLimitedReleaseByVersionError: null,

    deleteLimitedReleaseByVersionLoading: false,
    deleteLimitedReleaseByVersionData: null,
    deleteLimitedReleaseByVersionError: null,
  },
  action
) {
  switch (action.type) {
    case limitedReleaseByVersionConstants.LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        limitedReleaseByVersionLoading: true,
        limitedReleaseByVersionData: null,
        limitedReleaseByVersionError: null,
      });
    case limitedReleaseByVersionConstants.LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        limitedReleaseByVersionLoading: false,
        limitedReleaseByVersionData: action.data,
      });
    case limitedReleaseByVersionConstants.LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        limitedReleaseByVersionLoading: false,
        limitedReleaseByVersionData: null,
        limitedReleaseByVersionError: action.error,
      });
    case createLimitedReleaseByVersionConstants.CREATE_LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        createLimitedReleaseByVersionLoading: true,
        createLimitedReleaseByVersionData: null,
        createLimitedReleaseByVersionError: null,
      });
    case createLimitedReleaseByVersionConstants.CREATE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        createLimitedReleaseByVersionLoading: false,
        createLimitedReleaseByVersionData: action.data,
      });
    case createLimitedReleaseByVersionConstants.CREATE_LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        createLimitedReleaseByVersionLoading: false,
        createLimitedReleaseByVersionData: null,
        createLimitedReleaseByVersionError: action.error,
      });
    case editLimitedReleaseByVersionConstants.EDIT_LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        editLimitedReleaseByVersionLoading: true,
        editLimitedReleaseByVersionData: null,
        editLimitedReleaseByVersionError: null,
      });
    case editLimitedReleaseByVersionConstants.EDIT_LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        editLimitedReleaseByVersionLoading: false,
        editLimitedReleaseByVersionData: action.data,
      });
    case editLimitedReleaseByVersionConstants.EDIT_LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        editLimitedReleaseByVersionLoading: false,
        editLimitedReleaseByVersionData: null,
        editLimitedReleaseByVersionError: action.error,
      });
    case addTargetLimitedReleaseByVersionConstants.ADD_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        addTargetLimitedReleaseByVersionLoading: true,
        addTargetLimitedReleaseByVersionData: null,
        addTargetLimitedReleaseByVersionError: null,
      });
    case addTargetLimitedReleaseByVersionConstants.ADD_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        addTargetLimitedReleaseByVersionLoading: false,
        addTargetLimitedReleaseByVersionData: action.data,
      });
    case addTargetLimitedReleaseByVersionConstants.ADD_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        addTargetLimitedReleaseByVersionLoading: false,
        addTargetLimitedReleaseByVersionData: null,
        addTargetLimitedReleaseByVersionError: action.error,
      });
    case removeTargetLimitedReleaseByVersionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseByVersionLoading: true,
        removeTargetLimitedReleaseByVersionData: null,
        removeTargetLimitedReleaseByVersionError: null,
      });
    case removeTargetLimitedReleaseByVersionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseByVersionLoading: false,
        removeTargetLimitedReleaseByVersionData: action.data,
      });
    case removeTargetLimitedReleaseByVersionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseByVersionLoading: false,
        removeTargetLimitedReleaseByVersionData: null,
        removeTargetLimitedReleaseByVersionError: action.error,
      });
    case activateLimitedReleaseByVersionConstants.ACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        activateLimitedReleaseByVersionLoading: true,
        activateLimitedReleaseByVersionData: null,
        activateLimitedReleaseByVersionError: null,
      });
    case activateLimitedReleaseByVersionConstants.ACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        activateLimitedReleaseByVersionLoading: false,
        activateLimitedReleaseByVersionData: action.data,
      });
    case activateLimitedReleaseByVersionConstants.ACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        activateLimitedReleaseByVersionLoading: false,
        activateLimitedReleaseByVersionData: null,
        activateLimitedReleaseByVersionError: action.error,
      });
    case deactivateLimitedReleaseByVersionConstants.DEACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByVersionLoading: true,
        deactivateLimitedReleaseByVersionData: null,
        deactivateLimitedReleaseByVersionError: null,
      });
    case deactivateLimitedReleaseByVersionConstants.DEACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByVersionLoading: false,
        deactivateLimitedReleaseByVersionData: action.data,
      });
    case deactivateLimitedReleaseByVersionConstants.DEACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByVersionLoading: false,
        deactivateLimitedReleaseByVersionData: null,
        deactivateLimitedReleaseByVersionError: action.error,
      });
    case deleteLimitedReleaseByVersionConstants.DELETE_LIMITED_RELEASE_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        deleteLimitedReleaseByVersionLoading: true,
        deleteLimitedReleaseByVersionData: null,
        deleteLimitedReleaseByVersionError: null,
      });
    case deleteLimitedReleaseByVersionConstants.DELETE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        deleteLimitedReleaseByVersionLoading: false,
        deleteLimitedReleaseByVersionData: action.data,
      });
    case deleteLimitedReleaseByVersionConstants.DELETE_LIMITED_RELEASE_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        deleteLimitedReleaseByVersionLoading: false,
        deleteLimitedReleaseByVersionData: null,
        deleteLimitedReleaseByVersionError: action.error,
      });
    default:
      return state;
  }
}
